const nameConfigSettings = {
  label: 'Name',
  name: 'name',
  helper: 'Enter the name of this element',
  validation: 'required',
};

export default nameConfigSettings;
